import script from "./SubmissionSubmitPage.vue?vue&type=script&setup=true&lang=js"
export * from "./SubmissionSubmitPage.vue?vue&type=script&setup=true&lang=js"

import "./SubmissionSubmitPage.vue?vue&type=style&index=0&id=4256594c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4256594c"]])

export default __exports__